// extracted by mini-css-extract-plugin
export default {"sticky":"Sticky_sticky__G6uGC","smoothScroll":"Sticky_smoothScroll__L27xv","active":"Sticky_active__K+eV2","logo":"Sticky_logo__+ayCN"};